import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export default ({ cityId, typeIds, offset, first, name, orderBy, status }) => {
  const query = `query (
   $cityId: ID!
   $typeIds: [Int]
   $offset: Int
   $first: Int
   $name: String
   $orderBy: LocationOrderByEnum
   $status: LocationStatusEnum
  ) {
    city(id: $cityId){
      locations(
        offset: $offset
        first: $first
        name: $name
        orderBy: $orderBy
        status: $status
        typeIds: $typeIds
      ) {
        totalCount
        edges {
          node {
            id
            name
            label
            moments{
               morning
               lunch
               afternoon
            }
            isSheltered
            hasPermit
            isEvent
            status
            typeId
            type{
            name
            }
            latitude
            longitude
          }
        }
      }
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, {
    cityId,
    typeIds,
    offset,
    first,
    name,
    orderBy,
    status,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/gql.js